import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon } from 'lucide-react';
const HeaderAdv3 = () => {
  return <header className="bg-white" data-id="element-17102" data-mp="2dm9pa5xxpeur">
      {/* Top black bar */}
      <div className="bg-black h-2 w-full" data-id="element-17103" data-mp="1zocsp9jhd8g3"></div>
      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-3 sm:py-4" data-id="element-17104" data-mp="23pet3tp4vqjn">
        <div className="text-center pb-2 sm:pb-3 mb-2 sm:mb-3" data-id="element-17105" data-mp="23rhuf9vql63o">
          <h2 className="font-serif text-xl sm:text-2xl font-bold tracking-tight text-gray-900" data-id="element-17106" data-mp="1pwyxhdykausr">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-1 font-medium" data-id="element-17107" data-mp="1uqjoun5ngqiz">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>
        <div className="flex justify-start mb-2" data-id="element-17108" data-mp="1kz6wlufxvycf">
          <div className="text-xs text-gray-400 font-sans" data-id="element-17109" data-mp="16ymdsya0y2ix">Advertorial 3</div>
        </div>
        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-t border-gray-300 pt-2 gap-1 sm:gap-0" data-id="element-17110" data-mp="1bxz9m8ivijxn">
          <div className="text-left" data-id="element-17111" data-mp="3ekacqcayjv1m">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17112" data-mp="3ajqe14aqkjdd">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17113" data-mp="2qw96xb55yspw">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>
      {/* Article header */}
      <div className="px-4 sm:px-6 py-4 border-b border-gray-200" data-id="element-17114" data-mp="35mq76r62bcl7">
        <div className="max-w-4xl mx-auto" data-id="element-17115" data-mp="30t562q96a2hs">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium mb-3" data-id="element-17116" data-mp="30s3tghcid7xy">
            INVESTIGATIVE REPORT
          </div>
          <h1 className="font-serif text-2xl sm:text-3xl font-bold text-gray-900 leading-tight mb-4" data-id="element-17117" data-mp="28615qyl0yccc">
            How Retired Corning Specialist Re-Engineered Grounding Sheets Using
            25-Year-Old Submarine Cable Technology
          </h1>
          <p className="font-serif text-gray-700 text-base sm:text-lg mb-4 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-17118" data-mp="gz3hx52u8vh3">
            The engineering discovery that makes grounding sheets last for years
            while most sheets die after several washes
          </p>
          <div className="flex items-start mb-3 pb-3 border-b border-gray-200" data-id="element-17119" data-mp="3pahfxssmul24">
            <div className="w-10 h-10 overflow-hidden rounded-full flex-shrink-0 mr-2 border border-gray-300" data-id="element-17120" data-mp="3u8iy8bi8igcj">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5V1KLd9diP6p4Lsag55oX2/YYkJmGMhE_ELwA2hWH_Ii.jpg" alt="Patricia Chen" className="w-full h-full object-cover" data-id="element-17121" data-mp="22dswjqpc7ia" />
            </div>
            <div className="flex-1" data-id="element-17122" data-mp="1dikh6m5h6axv">
              <div className="flex items-center" data-id="element-17123" data-mp="1ii6vkyx1hx89">
                <div className="font-medium text-gray-900 text-sm" data-id="element-17124" data-mp="1igvw3bamnbmy">
                  By Patricia Chen, RN, MSN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-17125" data-mp="1snyflt7vmo3p">
                  <CheckCircleIcon className="h-3 w-3" data-id="element-17126" data-mp="1nnkg4zkccmha" />
                  <span className="text-xs ml-1 font-medium" data-id="element-17127" data-mp="1ivsmgg5w20mx">Verified</span>
                </div>
              </div>
              <div className="text-xs text-gray-600 mb-1" data-id="element-17128" data-mp="1etnx3tmh3q63">
                Former Head of Integrative Medicine, Cedar Sinai Medical Center
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-17129" data-mp="14wj87m18tgll">
                <div className="flex items-center mr-4" data-id="element-17130" data-mp="14v85lpjjaew2">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-17131" data-mp="zwoihlt7ex24" />
                  <span data-id="element-17132" data-mp="zz9mohgz5p31">4 min read</span>
                </div>
                <div className="flex items-center" data-id="element-17133" data-mp="vx67bhr6q0ch">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-17134" data-mp="2ubhehly01pul" />
                  <span data-id="element-17135" data-mp="2uaxsnu58ahba">24,867 views</span>
                </div>
              </div>
            </div>
          </div>
          <div className="text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17136" data-mp="2qanq6rgna916">
            <div className="flex items-center" data-id="element-17137" data-mp="2xdltdho7l7v6">
              <span className="font-medium mr-2" data-id="element-17138" data-mp="32bx37sei7ide">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="flex items-center" data-id="element-17139" data-mp="2obclkzkbrslh">
              <span className="font-medium mr-2" data-id="element-17140" data-mp="2oeqjnvlyhfn4">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderAdv3;